import React from "react";
import { Col, Row } from "antd";
import styled from "styled-components";
import XiQLightLogo from "../../../../assets/img/Loaders/XiQLightLogo.png";
import BlogItemLoader from "../../../Common/Components/BlogItemLoader";
import BlogItemTwoLoader from "../../../Common/Components/BlogItemTwoLoader";
import BlogItemLoaderCustom from "../../../Common/Components/BlogItemLoaderCustom";
import BlogItemTwoLoaderCustom from "../../../Common/Components/BlogItemTwoLoaderCustom";

interface IWhnPlaceholderProps {
  loading: boolean;
}

const WhnPlaceholder = (props: IWhnPlaceholderProps) => {
  const { loading } = props;

  return (
    <>
      {loading ? (
        <Wrapper>
          <Row gutter={24}>
            <Col className="gutter-row mb-3" span={12}>
              <div className="responsive-svg type-1">
                <BlogItemLoaderCustom />
              </div>
            </Col>
            <Col className="gutter-row mb-3" span={12}>
              <div className="responsive-svg type-1">
                <BlogItemLoaderCustom />
              </div>
            </Col>
            <Col className="gutter-row mb-3" span={12}>
              <div className="responsive-svg type-1 type-1-full">
                <BlogItemLoaderCustom />
              </div>
            </Col>
            <Col className="gutter-row mb-3" span={12}>
              <div className="small-three">
                <div className="responsive-svg type-2 mb-2">
                  {/* <BlogItemTwoLoader /> */}
                  <BlogItemTwoLoaderCustom />
                </div>
                <div className="responsive-svg type-2 mb-2">
                  <BlogItemTwoLoaderCustom />
                </div>
                <div className="responsive-svg type-2">
                  <BlogItemTwoLoaderCustom />
                </div>
              </div>
            </Col>
            <Col className="gutter-row mb-3" span={8}>
              <div className="responsive-svg type-1 type-1-3">
                <BlogItemLoaderCustom />
              </div>
            </Col>
            <Col className="gutter-row mb-3" span={8}>
              <div className="responsive-svg type-1 type-1-3">
                <BlogItemLoaderCustom />
              </div>
            </Col>
            <Col className="gutter-row mb-3" span={8}>
              <div className="responsive-svg type-1 type-1-3">
                <BlogItemLoaderCustom />
              </div>
            </Col>
            <Col className="gutter-row mb-3" span={12}>
              <div className="responsive-svg type-1">
                <BlogItemLoaderCustom />
              </div>
            </Col>
            <Col className="gutter-row mb-3" span={12}>
              <div className="responsive-svg type-1">
                <BlogItemLoaderCustom />
              </div>
            </Col>
          </Row>
        </Wrapper>
      ) : null}
    </>
  );
};

export default WhnPlaceholder;

const Wrapper = styled.div`
  margin-top: 20px;
  .responsive-svg {
    background-color: #fff;
    border-radius: 12px;
    box-shadow: rgba(0, 0, 0, 0.08) 0px 4px 12px;
    overflow: hidden;
    position: relative;
    height: 100%;
    &:before {
      background-image: url(${XiQLightLogo});
      background-repeat: no-repeat;
      background-position: center;
      top: 0;
      left: 0;
      content: "";
      position: absolute;
      height: 63%;
      width: 100%;
      z-index: 99;
    }
    svg {
      width: 100%;
      height: 100%;
      defs {
        linearGradient {
          stop {
            stop-color: #e9e9e9 !important;
            &:nth-of-type(2) {
              stop-color: #f6f6f6 !important;
            }
          }
        }
      }
    }
    &.type-1 {
      height: 355px;
      &:before {
        height: 230px;
      }
      .profile-img {
        height: 230px;
      }
      .title-m {
        margin-top: 21px;
      }
      &.type-1-3 {
        height: 294px;
        .profile-img {
          height: 170px;
        }
        .title-m {
          margin-top: 15px;
        }
        &:before {
          height: 170px;
          background-size: 90px;
        }
      }
      &.type-1-full {
        height: 420px;
        .profile-img {
          height: 295px;
        }
        &:before {
          height: 295px;
        }
        svg {
          height: 300px;
        }
      }
      svg {
        height: 350px;
        clipPath {
          rect {
            overflow: hidden;
            &:nth-child(1) {
              y: 90%;
              height: 5%;
              width: 30%;
            }
            &:nth-child(2) {
              y: 76%;
              height: 7%;
              width: 70%;
            }
            &:nth-child(3) {
              y: 65%;
              height: 7%;
              width: 80%;
            }
            &:nth-child(4) {
              height: 60%;
              width: 100%;
            }
          }
        }
      }
    }
    &.type-2 {
      height: auto;
      width: 100%;
      &:before {
        background-size: 40px;
        top: 15px;
        left: 10px;
        height: calc(100% - 30px);
        width: 100px;
      }
    }
    &.type-3 {
      background-color: transparent;
      box-shadow: none;
      border-radius: 0px;
      height: auto;
      &:before {
        background-size: 60%;
        top: 15px;
        left: 0;
        height: calc(100% - 25px);
        width: 11%;
      }
    }
  }
  .small-three {
    height: 100%;
    flex-flow: column wrap;
    display: flex;
    -webkit-box-pack: justify;
    justify-content: space-between !important;
    -webkit-box-align: center;
    align-items: center;
    &:not(.small-two-only) {
      div[role="DraggableBox"]:nth-of-type(2) {
        margin-top: 15px;
      }
    }
    &.small-two-only {
      justify-content: start;
    }
  }
`;
